import React, { useState, useEffect } from "react";
import { Card, CardTitle, CardBody, Row, Col } from "reactstrap";
import SingleSuperUserNotification from "./SingleSuperUserNotification";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import { fetchNotifications } from "../../actions/notificationActions";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

export default function AdminNotificationsShow({ schoolData, licenseData }) {
  const [notificationData, setNotificationData] = useState([]);
  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.notificationsReducer);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  useEffect(() => {
    if (!notifications.loading) {
      let tempNotifications = [...notifications.notifications];
      tempNotifications = tempNotifications.filter(
        (noti) => !noti.notice.isDeleted
      );
      tempNotifications = tempNotifications.sort(function (o1, o2) {
        return new Date(o2.notice.created) - new Date(o1.notice.created);
      });
      setNotificationData(tempNotifications);
    }
  }, [notifications.loading, notifications.notifications]);

  if (notifications.loading) {
    return <Pacmanloader />;
  }

  return (
    <Card>
      <CardBody>
        <CardTitle>
          <FormattedMessage id="Navigation_Notifications" />
        </CardTitle>
        <Row className="m-2 fw-bold">
          <Col lg="2">
            <FormattedMessage id="Title" />
          </Col>
          <Col lg="2">
            <FormattedMessage id="Date" />
          </Col>
          <Col lg="2">
            <FormattedMessage id="Programlicense" />
          </Col>
          <Col lg="2">
            <FormattedMessage id="School" />
          </Col>
          <Col lg="1">
            <FormattedMessage id="Receivers" />
          </Col>
          <Col lg="1" className="text-center">
            <FormattedMessage id="Popup" />
          </Col>
          <Col></Col>
        </Row>
        {notificationData.map((notification) => {
          return (
            <SingleSuperUserNotification
              key={notification.notice.id}
              notification={notification}
              schoolData={schoolData}
              licenseData={licenseData}
            />
          );
        })}
      </CardBody>
    </Card>
  );
}
